import { render, staticRenderFns } from "./UserOnlineStatus.vue?vue&type=template&id=52ca337c&"
import script from "./UserOnlineStatus.vue?vue&type=script&lang=js&"
export * from "./UserOnlineStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports